<ion-header no-shodow>
  <ion-toolbar no-border>
    <ion-buttons slot="start">
      <ion-back-button
        onclick="event.stopImmediatePropagation();"
        (mouseup)="closeModal()"
        defaultHref=""
        color="light"
        [icon]="'ios-arrow-back'"
        [text]="''"
      ></ion-back-button>
    </ion-buttons>
    <ion-title text-left no-padding>
      <div class="modal-title-text" text-wrap>
        <ion-text font-bold="" color="light">{{ document?.fileName }}</ion-text>
      </div>
    </ion-title>
    <ion-buttons slot="end" *ngIf="componentOptions?.showDownload">
      <ion-button (click)="downloadClicked()" fill="clear" color="light">
        <ion-icon name="download"></ion-icon>
        <span>DOWNLOAD</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col text-center size="12" class="img-col">
        <div>
          <img [src]="document?.url" alt="" #img />
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col size="12" text-center class="zoom-buttons" margin-bottom>
        <ion-button (click)="zoomIn(img)">
          <ion-icon slot="icon-only" name="add-circle-outline"></ion-icon>
        </ion-button>
        <ion-button (click)="zoomOut(img)">
          <ion-icon slot="icon-only" name="remove-circle-outline"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
<!--
<ion-grid>
    <ion-row>
        <ion-col size="12" >
            <ion-text color="light" float-start>Invoice No. 6456</ion-text>
            <ion-icon name="trash" float-end></ion-icon>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col size="12">
            <ion-button  (click)="closeModal()"></ion-button>
        </ion-col>
        <ion-col size="12">
            <img [src]="imageUrl" alt="" />
        </ion-col>
    </ion-row>
</ion-grid>
-->
